import { Badge } from "@mantine/core";
import { IconShieldLock, IconUser, IconUserShield } from "@tabler/icons-react";

/**
 * Lencana tingkatan satu baris pengguna.
 *
 * Superadmin bukan nilai `User.role` — dia berasal dari `ADMIN_EMAIL` — jadi
 * tanpa lencana sendiri akun superadmin terbaca sebagai "Admin" biasa dan
 * tingkatannya tidak terlihat. Lencana ini yang membedakannya.
 */
export function UserRoleBadge({
	role,
	isSuperAdmin,
}: {
	role: string | null;
	isSuperAdmin: boolean;
}) {
	if (isSuperAdmin)
		return (
			<Badge
				color="grape"
				variant="filled"
				leftSection={<IconShieldLock size={12} />}
			>
				Superadmin
			</Badge>
		);
	if (role === "admin")
		return (
			<Badge
				color="orange"
				variant="light"
				leftSection={<IconUserShield size={12} />}
			>
				Admin
			</Badge>
		);
	return (
		<Badge color="blue" variant="light" leftSection={<IconUser size={12} />}>
			Pengguna
		</Badge>
	);
}
